<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <!-- <button class="btn add">
              <i class="fas fa-download ms-1"></i>
              تحميل الجدول
            </button> -->
            <download-excel
              :data="json_data"
              :fields="json_fields"
              class="btn add"
              :name="
                'exam-' + examId + '-result-' + new Date().getTime() + '.xls'
              "
              :header="exam.title"
            >
              <i class="fas fa-download ms-1"></i>
              تحميل الجدول
            </download-excel>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortResultsAsc">
                  ترتيب الدرجات تصاعديا
                </li>
                <li class="dropdown-item" @click="sortResultsDesc">
                  ترتيب الدرجات تنازليا
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table
              v-show="this.students.length > 0"
              class="table table-striped"
            >
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th class="fit" scope="col">المستخدم</th>
                  <th scope="col">اسم طالب</th>
                  <th scope="col">رقم الطالب</th>
                  <th scope="col">نتيجة الطالب</th>
                  <th scope="col">حالة التصحيح</th>
                  <th class="controls" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in this.students" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>
                    <div class="user__image" v-if="student.user.avatar_url">
                      <img
                        class="userImg w-100"
                        :src="student.user.avatar_url"
                        alt="user_photo"
                      />
                    </div>
                    <div class="user__image" v-if="!student.user.avatar_url">
                      <img
                        class="userImg w-100"
                        src="@/assets/img_avatar.png"
                        alt="user_photo"
                      />
                    </div>
                  </td>
                  <td>{{ student.user.user_name }}</td>
                  <td>{{ student.user.phone }}</td>
                  <td>{{ formatScore(student) }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="isGraded(student) ? 'bg-success' : 'bg-warning'"
                    >
                      {{ isGraded(student) ? "تم التصحيح" : "لم يتم التصحيح" }}
                    </span>
                  </td>
                  <td class="controls">
                    <router-link
                      class="btn edit"
                      :to="{
                        name: 'exam_grade_student',
                        params: {
                          id: examId,
                          studentId: student.student_id,
                        },
                      }"
                    >
                      <i class="fas fa-pen-to-square ms-1"></i>
                      تصحيح
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav
              class="pagination"
              v-show="this.isShowButton"
              aria-label="Page navigation"
            >
              <button
                class="btn add"
                @click="this.getNextSelectedData"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>

            <div
              v-show="
                (!this.isloading && !this.students) || this.students.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد طلاب</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      currentView: "الطلاب",
      // Loading
      isloading: true,
      // exam id
      examId: this.$route.params.id,
      // Students
      students: [],
      // Pagination
      loadingMore: false,
      isShowButton: true,
      // Search
      searchResult: [],
      searchValue: "",
      json_data: [],
      exam: {},
      json_fields: {
        Name: "student.user.user_name",
        // "E-mail address": "student.email",
        Mobile: "student.user.phone",
        // "Parent phone": "student.parent_phone",
        "Exam title": "exam.title",
        Degree: "exam.degree",
        // Type: "type",
        Result: "result",
        Status: "type",
        duration: "exam.duration",
        // URL: "result_url",
      },
    };
  },
  methods: {
    ...mapActions("examsModule", [
      "searchData",
      "changeOrderBy",
      "changeSortBy",
      "getFirstData",
      "getNextData",
      "getExamById",
    ]),

    // "7 من 10" — a mark out of the exam total, never a bare number and never
    // `undefined.toFixed()` when a result has no score yet.
    formatScore(student) {
      const total = Number(this.exam?.degree) || 0;
      const earned = this.earnedScore(student);
      const formatted = Number.isInteger(earned) ? earned : earned.toFixed(1);
      return total > 0 ? `${formatted} من ${total}` : `${formatted}`;
    },

    // MCQ marks plus whatever the teacher has awarded on the essay questions.
    earnedScore(student) {
      const mcq = Number(student?.score);
      const essay = Number(student?.essay_degree);
      const safeMcq = Number.isFinite(mcq) && mcq > 0 ? mcq : 0;
      const safeEssay = Number.isFinite(essay) ? essay : 0;
      return safeMcq + safeEssay;
    },

    isGraded(student) {
      // A result with no essay questions is graded the moment it is submitted.
      return (student?.status ?? "graded") === "graded";
    },

    // Sort
    sortByCreateDate() {
      this.changeOrderBy("created_date");
      this.changeSortBy("desc");
      this.getFirstData(this.examId);
    },
    sortResultsAsc() {
      this.changeOrderBy("score");
      this.changeSortBy("asc");
      this.getFirstData(this.examId);
    },
    sortResultsDesc() {
      this.changeOrderBy("score");
      this.changeSortBy("desc");
      this.getFirstData(this.examId);
    },

    // Search
    async getDocBySeacrh(e) {
      let payload = {
        id: this.examId,
        searchValue: e.target.value,
      };

      if (e.target.value == "") {
        this.students = this.getStudents;
        this.avalabileSteps = this.saveAvalabileSteps;
        this.isSteps = this.saveSteps;
      } else {
        setTimeout(() => {
          this.searchData(payload);
          this.students = this.searchResult;
          this.isSteps = 0;
          this.avalabileSteps = 0;
        }, 800);
      }
    },
    // Pagination
    getNextSelectedData() {
      this.getNextData(this.examId);
    },
    getPrevSelectedData() {
      this.getPrevData(this.examId);
    },
  },
  async created() {
    await this.getFirstData(this.examId);
  },
  computed: {
    ...mapGetters("examsModule", [
      "isLoading",
      "firstLoad",
      "getStudents",
      "getSearchResult",
      // Pagination
      "isShowLoadingButton",
      "isLoadingMore",
    ]),
  },
  async mounted() {
    // Data
    // this.students = this.getStudents;
    let result = [];
    // Data
    result = await this.getStudents;
    this.students = result;

    this.exam = await this.getExamById(this.examId);

    // this.json_data = await Promise.all(
    // );
    this.json_data = this.students.map((e) => {
      return {
        student: {
          ...e,
        },
        exam: this.exam,
        result: this.earnedScore(e),
        type: this.isGraded(e) ? "تم التصحيح" : "لم يتم التصحيح",
      };
    });

    // Loading
    this.isloading = this.isLoading;
    // Search
    this.searchResult = this.getSearchResult;
    // Pagination
    this.isShowButton = this.isShowLoadingButton;
    this.loadingMore = this.isLoadingMore;
  },
  watch: {
    // Loading
    isLoading() {
      this.isloading = this.isLoading;
    },
    // Data
    getStudents() {
      this.students = this.getStudents;
    },
    // Search
    getSearchResult() {
      this.searchResult = this.getSearchResult;
    },
    // Pagination
    isLoadingMore() {
      this.loadingMore = this.isLoadingMore;
    },
    isShowLoadingButton() {
      this.isShowButton = this.isShowLoadingButton;
    },
  },
};
</script>

<style>
</style>